<template>
  <div class="about">
    <modal v-if="showWhatModal" @close="showWhatModal = false">
      <h3 slot="header">What is this site?</h3>
      <p slot="body">
        Uniqitty /uni'kitty/ is a real-time cat name storage app. <br><br>
        Some cat owners think of some great names for their cats. I felt like it'd be interesting to showcase these and learn some Vue.js at the same time.<br><br>
        If you enjoy Uniqitty - consider <a href="https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=FWTPPZ352LBMC">donating</a> to give more functionality!
      </p>
    </modal>
    <modal v-if="showHowModal" @close="showHowModal = false">
      <h3 slot="header">How do I use Uniqitty?</h3>
      <p slot="body">Just add your cats name in the box below!<br>If you have more than one, feel free to add that one too.<br><br><small>Try not to spam or fill it with junk..</small></p>
    </modal>
    <modal v-if="showWhoModal" @close="showWhoModal = false">
      <h3 slot="header">Who made this?</h3>
      <p slot="body">
        <a href="http://www.chrisgregori.co.uk">Chris Gregori</a> | <a href="https://twitter.com/_ChrisGreg">@_ChrisGreg</a><br><br>I am a Software Engineer who's enjoys making silly little apps.<br><small>Donate or follow me on various networks if you'd like to keep up with my projects</small></p>
      </p>
    </modal>
    <ul>
      <li v-on:click="showWhatModal = true">What?</li>
      <li v-on:click="showHowModal = true">How?</li>
      <li v-on:click="showWhoModal = true">Who?</li>
    </ul>
    <h3 class="online">Currently <span class="cool-cats">{{ numberOfUsers }} cool {{ peopleText }}</span> online looking at cool cats.</h3>
  </div>
</template>


<script>
import firebase from 'firebase';
import Modal from './modals/modal';

export default {

  components: {
    Modal
  },

  data() {
    return {
      numberOfUsers: 0,
      showWhatModal: false,
      showHowModal: false,
      showWhoModal: false
    };
  },

  computed: {
    peopleText: function() {
      return this.numberOfUsers > 1 ? 'cats' : 'cat'
    }
  },

  mounted () {
    var listRef = new Firebase('https://uniquitty-10845.firebaseio.com/presence/');
    var userRef = listRef.push();

    // Add ourselves to presence list when online.
    var presenceRef = new Firebase("https://uniquitty-10845.firebaseio.com/.info/connected");
    presenceRef.on("value", function(snap) {
      if (snap.val()) {
        // Remove ourselves when we disconnect.
        userRef.onDisconnect().remove();
        userRef.set(true);
      }
    });

    // Number of online users is the number of objects in the presence list.
    listRef.on("value", function(snap, err) {
      this.numberOfUsers = snap.numChildren();
    }, this);

  }
};
</script>

<style>
  .about {
    width: 30%;
    text-align: center;
    margin: 0px auto;
    padding-bottom: 1%;
    font-family: 'Open Sans';
    text-transform: uppercase;
    color: #e26839;
    letter-spacing: 2px;
    font-size: 1rem;
  }
  .cool-cats {
    color: #e23942;
    font-size: 0.7rem;
    font-family: Open Sans;
  }
  ul {
    list-style: none;
    display: flex;
    justify-content: space-between;
    margin-top: 1%;
  }
  li {
    display: inline-block;
    color: #e26839;
    text-transform: uppercase;
    font-size: 1rem;
  }
  li:hover {
    cursor: pointer;
    color: #42b983;
  }
  .online {
    margin-top: 5%;
    font-size: 0.7rem;
  }

  @media(max-width: 980px) {
    .about {
      width: 80%;
      margin-bottom: 5%;
    }
    li {
      font-size: 2.7rem;
    }
    .online {
      margin-top: 5%;
      font-size: 2rem;
    }
    .cool-cats {
      font-size: 2rem;
      font-family: Open Sans;
    }
  }

</style>



// WEBPACK FOOTER //
// About.vue?17a2c066